.wrapper {
  width: 100%;
}

.card {
  margin-bottom: 2rem;
}

.actions {
  margin-top: 1rem;
  display: flex;
  gap: var(--spacing-x-normal);
}
